module.exports = __webpack_public_path__ + "img/predatory-ambition.2ef41c10.png";